/*************************************************/
/* Slider                                        */
/*************************************************/
import Swiper from 'swiper';
import  { Navigation, Autoplay, EffectFade, Pagination, Thumbs } from "swiper/modules";
Swiper.use([Navigation, Autoplay, EffectFade, Pagination, Thumbs]);
import SwiperHelpers from './swiperHelpers.js';
import customEventsNames from '../customEventsNames.js';
export function slider() {
    const latestArticlesInformationalSliderSelector = ".latest-articles--informational .latest-articles__cards.swiper";
    const latestArticlesShowcaseSliderSelector = ".latest-articles--showcase .latest-articles__cards.swiper";

    const cardsSliderSelector = ".cards__list-slider.swiper";

    const brandsSliderSelector = ".brands-slider__slider.swiper";

    const vehicleImagesSliderSelector = ".vehicle-info__images.swiper";
    const vehicleImagesThumbsSliderSelector = ".vehicle-info__thumbs.swiper"
    const vehicleImagesZoomToggleSelector = ".vehicle-info__images-item-zoom-toggle";

    const vehicleEquipmentImagesSliderSelector = ".vehicle-equipment__images.swiper";

    const mobileMenuCardsSliderSelector = ".menu-nav-mobile__cards-wrap.swiper";

    const init = function () {

        //Slider for cards in mobile menu
        const mobileMenu = document.querySelector('.menu-nav-mobile');
        const mobileMenuCardsSliderElement = document.querySelector(mobileMenuCardsSliderSelector);
        if(mobileMenu && mobileMenuCardsSliderElement){
            var mobileMenuCardsSlider 
            
            mobileMenu.addEventListener(customEventsNames.mobileMenuOpened, e => {
                mobileMenuCardsSlider = new Swiper(mobileMenuCardsSliderElement,{
                    spaceBetween:10,
                    slidesPerView:'auto',
                    slidesOffsetAfter:15,
                    observeParents:true
                });
            });

            mobileMenu.addEventListener(customEventsNames.mobileMenuClosed, e => {
                if(mobileMenuCardsSlider){
                    mobileMenuCardsSlider.destroy();
                }
            });
        }

        //Vehicle images sliders
        const vehicleImagesSliderElement = document.querySelector(vehicleImagesSliderSelector);
        const vehicleImagesThumbsSliderElement = document.querySelector(vehicleImagesThumbsSliderSelector);
        if (vehicleImagesSliderElement && vehicleImagesThumbsSliderElement) {

            const vehicleImagesThumbsSlider = new Swiper(vehicleImagesThumbsSliderElement, {
                spaceBetween: 10,
                slidesPerView: 3,
                loop: false,
                watchSlidesProgress: true,
                breakpoints: {
                    // when window width is >= 625px
                    500: {
                        slidesPerView: 4,
                    },
                    // when window width is >= 625px
                    625: {
                        slidesPerView: 3,
                    },
                    // when window width is >= 1125px
                    1125: {
                        slidesPerView: 5,
                    }
                },
            });

            const vehicleImagesSlider = new Swiper(vehicleImagesSliderElement, {
                speed: 500,
                loop: false,
                slidesPerView: 1,
                navigation: {
                    nextEl: '#' + vehicleImagesSliderElement.id + " .slider-navigation__next",
                    prevEl: '#' + vehicleImagesSliderElement.id + " .slider-navigation__prev",
                },
                thumbs: {
                    swiper: vehicleImagesThumbsSlider
                },
                on: {
                    slideChange: () => {
                        SwiperHelpers.handleSlideChange();
                        

                    },
                    slideChangeTransitionEnd: (swiper) => {
                        SwiperHelpers.handleSlideChangeTransitionEnd(swiper);

                        //Update the zoom toggle for the right image
                        const zoomToggle = swiper.el.querySelector(vehicleImagesZoomToggleSelector);
                        if(zoomToggle){
                            zoomToggle.dataset.fancyboxIndex = swiper.activeIndex;
                        }
                    }
                }
            });
        }

        //Vehicle equipment images sliders
        const vehicleEquipmentImagesSliderElement = document.querySelector(vehicleEquipmentImagesSliderSelector);
        if (vehicleEquipmentImagesSliderElement) {

            const vehicleEquipmentImagesSlider = new Swiper(vehicleEquipmentImagesSliderElement, {
                speed: 500,
                loop: false,
                slidesPerView: 1,
                navigation: {
                    nextEl: '#' + vehicleEquipmentImagesSliderElement.id + " .slider-navigation__next",
                    prevEl: '#' + vehicleEquipmentImagesSliderElement.id + " .slider-navigation__prev",
                },
                on: {
                    slideChange: () => {
                        SwiperHelpers.handleSlideChange();
                    },
                    slideChangeTransitionEnd: (swiper) => {
                        SwiperHelpers.handleSlideChangeTransitionEnd(swiper);
                    }
                }
            });
        }


        //Articles sliders
        const articlesInformationalSlider = [];
        const articlesInformationalSliderElements = document.querySelectorAll(latestArticlesInformationalSliderSelector);
        if (articlesInformationalSliderElements) {
            articlesInformationalSliderElements.forEach(slider => {

                articlesInformationalSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1,
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .slider-pagination",
                        type: 'bullets'
                    },
                    breakpoints: {
                        // when window width is >= 480px
                        480: {
                            slidesPerView: 2,
                        },
                        // when window width is >= 960px
                        960: {
                            slidesPerView: 3,
                        }
                    },
                    spaceBetween: 30,
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            SwiperHelpers.handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            SwiperHelpers.handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        const articlesShowcaseSlider = [];
        const articlesShowcaseSliderElements = document.querySelectorAll(latestArticlesShowcaseSliderSelector);
        if (articlesShowcaseSliderElements) {
            articlesShowcaseSliderElements.forEach(slider => {

                articlesShowcaseSlider.push(new Swiper(slider, {
                    speed: 750,
                    slidesPerView: 1,
                    centeredSlides: true,
                    autoplay:{
                        deplay:5000
                    },
                    loop: true,
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .slider-pagination",
                        type: 'bullets'
                    },
                    spaceBetween: 30,
                    breakpoints: {
                        // when window width is >= 768px
                        768: {
                            slidesPerView: "auto",

                        }
                    },
                    navigation: {
                        nextEl: '#' + slider.dataset.componentId + " .slider-navigation__next",
                        prevEl: '#' + slider.dataset.componentId + " .slider-navigation__prev",
                    },
                    on: {
                        slideChange: () => {
                            SwiperHelpers.handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            SwiperHelpers.handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Cards sliders
        const cardsSlider = [];
        const cardsSliderElements = document.querySelectorAll(cardsSliderSelector);
        if (cardsSliderElements) {
            cardsSliderElements.forEach(slider => {

                cardsSlider.push(new Swiper(slider, {
                    speed: 500,
                    loop: false,
                    slidesPerView: 1,
                    pagination: {
                        el: '#' + slider.dataset.componentId + " .slider-pagination",
                        type: 'bullets'
                    },
                    spaceBetween: 30,
                    on: {
                        slideChange: () => {
                            SwiperHelpers.handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            SwiperHelpers.handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                }));
            })
        }

        //Brands sliders
        const brandsSlider = [];
        const brandsSliderElements = document.querySelectorAll(brandsSliderSelector);
        if (brandsSliderElements) {
            const navigationElementEvents = ['mouseenter', 'focusin'];
            brandsSliderElements.forEach(slider => {
                const navigationItems = [...slider.parentElement.querySelectorAll('.brands-slider__navigation-item:not(.brands-slider__navigation-item--top-level)')];

                const swiperObj = new Swiper(slider, {
                    centeredSlides: true,
                    loop: true,
                    speed: 500,
                    allowTouchMove: false,
                    slidesPerView: "auto",
                    on: {
                        afterInit: (swiper) => {
                            if (navigationItems) {
                                const activeSlide = swiper.el.parentElement.querySelector('.brands-slider__navigation-item--active:not(.brands-slider__navigation-item--top-level)');
                                if (activeSlide) {
                                    const activeSlideIndex = navigationItems.indexOf(activeSlide);
                                    swiper.slideToLoop(activeSlideIndex, 0);
                                }
                            }

                            setTimeout(() => {
                                swiper.el.classList.add(
                                    "brands-slider__slider--initialized"
                                );
                            }, 250); //Wait for the transition to be over, then show the slider
                        },
                        slideChange: () => {
                            SwiperHelpers.handleSlideChange();
                        },
                        slideChangeTransitionEnd: (swiper) => {
                            SwiperHelpers.handleSlideChangeTransitionEnd(swiper);

                        }
                    }
                });

                if (navigationItems) {
                    navigationItems.forEach(item => {
                        navigationElementEvents.forEach(event => {
                            item.addEventListener(event, e => {
                                const index = navigationItems.indexOf(item);
                                swiperObj.slideToLoop(index, 500);
                            });
                        });
                    });
                }

                brandsSlider.push(swiperObj);
            })
        }
    };

    init();
}
